module.exports = __webpack_public_path__ + "media/img/help_center/Institution_Scholarship_Creation_20-e87be1683ba9fe505fae2e5413e76ae9.jpg";